import { render, staticRenderFns } from "./PermissionsRadio.vue?vue&type=template&id=78b43a8e&scoped=true"
import script from "./PermissionsRadio.vue?vue&type=script&lang=js"
export * from "./PermissionsRadio.vue?vue&type=script&lang=js"
import style0 from "./PermissionsRadio.vue?vue&type=style&index=0&id=78b43a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b43a8e",
  null
  
)

export default component.exports